import React from "react";
import Button from "react-bootstrap/es/Button";
import {Col, Row} from "react-bootstrap";
import {InputWithLabel} from "../../component/Form/InputWithLabel";

class GridCompanies {
  title = "Lista de Empresas";

  customFilters = {domain: null, friendlyName: null}

  columns = [
    {
      Header: "Nome",
      accessor: "name",
      HeaderColumn: true
    },
    {
      Header: "Domínio",
      accessor: "domain"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
        <Button bsStyle="success" href={"#/companies/" + row.original.id + "/edit"} block>Editar</Button>
      )
    }
  ];
  customFilterComponent = (_props, _state, onChange) => {

    return (
      <Row className="align-items-center">
        <Col md={6}>
          <InputWithLabel
            label="Nome" placeholder="Digite o Nome"
            onChangeWithDelay={e => {
              this.customFilters.friendlyName = e.trim()
              onChange(this.customFilters)
            }}
          />
        </Col>
        <Col md={6}>
          <InputWithLabel
            label="Domínio" placeholder="Busca de Domínios"
            onChangeWithDelay={e => {
              this.customFilters.domain = e.trim()
              onChange(this.customFilters)
            }}
          />
        </Col>
      </Row>
    )
  }
  endpoint = () => {
    const params = new URLSearchParams({})
    const {friendlyName, domain} = this.customFilters

    friendlyName && params.append('name', friendlyName)
    domain && params.append('domain', domain)

    return `auth/v1/companies?${params.toString()}`
  }
}

export default GridCompanies;



// WEBPACK FOOTER //
// ./src/customGrid/entities/Companies.js